module.exports = __webpack_public_path__ + "img/28.9.TU.3bd35baa.png";